import i18next from "i18next";

/**
 * @returns retorna as iniciais do dias da semana de acordo com o numero
 * @param {Number} weekDayNumber
 */
export const getWeekDayInitiais = (weekDayNumber) => {
    const weekDays = i18next.t("date.week-days-initiais", { returnObjects: true });
    return weekDays[weekDayNumber];
};

/**
 * @returns retorna as iniciais do mes de acordo com o numero
 * @param {Number} monthNumber
 */
export const getMonthInitiais = (monthNumber) => {
    const Months = i18next.t("date.months-initiais", { returnObjects: true });
    return Months[monthNumber];
};


/**
 * @returns retorna a string do mes de acordo com o numero
 * @param {Number} monthNumber
 */
export const getMonthString = (monthNumber) => {
    const Months = i18next.t("date.months", { returnObjects: true });
    return Months[monthNumber];
};

/**
 * @returns retorna o número com um 0 antes caso ele tenha apenas um digito
 * @param {Number} number
 */
export const getDataString = (number)=>{
    return number.toString().length<=1 ? '0'+number.toString() : number.toString()
}

/**
 * @returns retorna o ultimo dia do mes
 * @param {Number} month
 * @param {Number} year
 */
export const getLastDay = (month, year) =>{
    const dataObject = new Date();
    const currentmonth = dataObject.getMonth();
    const currentyear = dataObject.getFullYear();
    if(currentmonth+1 === parseInt(month) && currentyear === parseInt(year)){
        return getDataString(dataObject.getDate())
    }
    const LastDay = {
        '01': '31',
        '02': year % 4 === 0 ? '29' : '28',
        '03': '31',
        '04': '30',
        '05': '31',
        '06': '30',
        '07': '31',
        '08': '31',
        '09': '30',
        '10': '31',
        '11': '30',
        '12': '31',
    }
    return LastDay[month]
}

/**
 * @returns retorna a data formato dd/mm - hh:mm
 * @param {dataObject} time
 */
export const getEquipamentTime = (time) => {
    const data = new Date(time);
    if(time){
        return getDataString(data.getDate())+'/'+getDataString(data.getMonth()+1)+' - '+getDataString(data.getHours())+':'+getDataString(data.getMinutes());
    }else{
        return 'Sem registro de horário';
    }
}

/**
 * @returns retorna a data formato dd/mm/yyyy - hh:mm
 * @param {dataObject} time
 */
export const getDataformat = (time) => {
    const data = new Date(time);
    if(time){
        return getDataString(data.getDate())+'/'+getDataString(data.getMonth()+1)+'/'+data.getFullYear()+' - '+getDataString(data.getHours())+':'+getDataString(data.getMinutes());
    }else{
        return 'Sem registro de horário';
    }
}

/**
 * @returns retorna a data formato yyy/mm/dd hh:mm:ss
 * @param {dataObject} time
 */
export const formatarDataParaYMDHMS = (time) => {
    try {
        let data = new Date(time)
        const year = data.getFullYear();
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        const seconds = String(data.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } catch (error) {
        console.log('Erro ao formatar data: '+error)
        return null;
    }
}